import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Core2Config} from '../shared/core2Config';
import {AppletStoreContainerModel} from '../../../../../models/aggregates/applet-store';

@Injectable({providedIn: 'root'})
export class AppletStoreService extends BaseApiTemplateService<AppletStoreContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-store';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-store';
    this.httpClient = http;
  }
}
